export default __webpack_public_path__ + "static/media/add-comment-icon-white.5cdf02b7.svg";